import Model from "./model"
import errorDialog from "@/views/ErrorDialog/errorDialog";
import ApiTimeEntry from "@/api/time_entry/timeEntry";
import {formatSysDateTime, parseSysDate, formatSysDate} from "@/plugins/formatting";
import {$t} from "@/i18n";
import Loader from "@/utility/loader";

export default class Controller {
    constructor(isMobile, adminView, editTaskId, runningTaskId, currentPersonId, isReadOnly, editTaskVirtualId, emit) {
        this.model = new Model(isMobile, adminView, editTaskId, runningTaskId, currentPersonId, isReadOnly, editTaskVirtualId)
        this.emit = emit
        this.loader = new Loader()
    }

    setTimeEntries(value) {
        this.model.setTimeEntries(value)
    }

    async loadData(timeStatus, existingTimeEntry, company, topic, limit= 100) {
        try {
            if (this.model.editTaskId) {
                let timeEntries

                if (this.model.adminView) {
                    timeEntries = await ApiTimeEntry.getAllTimeEntries(this.model.editTaskId,limit)
                } else {
                    timeEntries = await ApiTimeEntry.getCurrentPersonTimeEntries(this.model.editTaskId, limit)
                }

                this.model.timeEntries = timeEntries.map(x => {
                    x.dirty = false
                    if(!x.end && x.start) {
                        // this is a situation wherein multiple people's time entries are running
                        x.end = formatSysDate(parseSysDate(x.start))
                    }
                    return x
                })

                if (this.model.runningTaskId !== this.model.editTaskId || timeStatus !== "running") {
                    this.model.addEmptyRow(company, topic);
                }
            } else if (existingTimeEntry) {
                let existingTimeEntryCopy = { ...existingTimeEntry }
                existingTimeEntryCopy.dirty = false

                this.model.timeEntries.push(existingTimeEntryCopy)
                this.model.timeEntries.forEach((entry) => {
                    if(!entry.end && entry.start) {
                        // this is a situation wherein multiple people's time entries are running
                        entry.end = formatSysDate(parseSysDate(entry.start))
                    }
                })
            } else {
                this.model.addEmptyRow(company, topic);
            }

            this.model.lastTimeEntry = await ApiTimeEntry.getLastTimeEntry()

        } catch(ex) {
            errorDialog.showError(ex);
        }
    }

    toggleBillable(timeEntry) {
        this.model.toggleBillable(timeEntry)
    }

    datePicked(timeEntry, date) {
        this.model.datePicked(timeEntry, date)
    }

    setStartTime(timeEntry, date) {
        this.model.setStartTime(timeEntry, date)
    }

    setEndTime(timeEntry, date) {
        this.model.setEndTime(timeEntry, date)
    }

    setDuration(timeEntry, duration) {
        this.model.setDuration(timeEntry, duration)
    }

    setLastTime(time) {
        this.model.setLastTime(time)
    }

    async saveTimeEntry (time_entry, index, company, topic) {
        this.model.timeEntryErrors = []
        if (!this.model.validate_save_time_entry(time_entry, index)) return;

        let data = {
            id: time_entry.id,
            start: time_entry.start,
            end: this.model.getTimeEntryFormattedEnd(time_entry) === '' ? null : time_entry.end,
            duration: time_entry.duration,
            person_id: time_entry.person_id ? time_entry.person_id : this.model.currentPersonId,
            description: time_entry.description,
            //TODO: task_id: this.model.editTaskId == null || this.model.editTaskId === 0 ? props.taskVirtualId : props.taskId,
            task_id: this.model.editTaskId,
            billable: time_entry.billable ? 1 : 0
        };

        if (this.model.editTaskId === 0 && (this.model.editTaskVirtualId == null || this.model.editTaskVirtualId === 0)) {
            this.emit("set_time", data)
            return;
        }

        try {
            const resp = await ApiTimeEntry.saveTimeEntry(data)
            time_entry.dirty = false;
            if (time_entry.id === 0) {
                time_entry.id = resp.id;
                time_entry.running = this.model.getTimeEntryFormattedEnd(time_entry) === '';
                if (!time_entry.running) {
                    this.model.addEmptyRow(company, topic);
                }
            } else {
                if (this.model.getTimeEntryFormattedEnd(this.model.timeEntries[0]) !== '') {
                    this.model.addEmptyRow(company, topic);
                }
            }
        } catch (ex) {
            errorDialog.showError(ex)
        }
    }

    editTimeEntryComment(index) {
        this.model.setEditTimeEntryIndex(index)
    }

    async saveEditTimeEntryDescription(description) {
        this.model.setTimeEntryDescription(description.trim())
        const timeEntry = this.model.timeEntries[this.model.editTimeEntryIndex]
        if (timeEntry.id && !timeEntry.dirty) {
            await this.loader.withLoader(async () => {
                await ApiTimeEntry.saveExistingTimeEntryDescription(timeEntry.id, this.model.getEditTimeEntryDescription())
            })
        } else {
            timeEntry.dirty = true
        }

        this.model.setEditTimeEntryIndex(null)
    }

    closeEditTimeEntryDescription() {
        this.model.setEditTimeEntryIndex(null)
    }

    setRunningTaskId(value) {
        this.model.setRunningTaskId(value)
    }
}